import React from 'react';
import classnames from 'classnames';

// Components
import { WpCollapsible } from '../collapsible';
import { WpText } from '../text';
import { WpIcon } from '../icon';

// Styles
import './WpCollapsibleGroupItem.scss';

type Props = {
  collapsibleId: string;
  isOpen?: boolean;
  onClick?: Function;
  children: React.ReactNode;
  title: string;
  number?: number;
};

const WpCollapsibleGroupItem = ({ collapsibleId, isOpen, onClick, children, title, number }: Props) => {
  const handleToggle = () => {
    onClick(collapsibleId);
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleToggle();
    }
  };

  const baseClassName = 'WpCollapsibleGroupItem';
  const classes = classnames(baseClassName, number ? `${baseClassName}--indent-lg` : `${baseClassName}--indent-sm`);

  return (
    <div className={classes}>
      <div
        className={`${baseClassName}__header`}
        onKeyDown={handleKeyDown}
        onClick={handleToggle}
        role="button"
        tabIndex={0}
      >
        {!!number && (
          <div className={`${baseClassName}__header__number`}>
            <WpText variant="bodySm" tag="span" noMargin bold>
              {number}
            </WpText>
          </div>
        )}
        <div className={`${baseClassName}__header__title`}>
          <WpText bold={isOpen} noMargin variant="bodyMd">
            {title}
          </WpText>
        </div>
        <WpIcon name={isOpen ? 'chevron-up' : 'chevron-down'} />
      </div>
      <WpCollapsible open={isOpen}>
        <div className={`${baseClassName}__content`}>{children}</div>
      </WpCollapsible>
    </div>
  );
};

export default WpCollapsibleGroupItem;
